import React, { Fragment } from "react";
import Text from "../Text";

const UserInfo = ({ user, label = "" }) => {
  if (!user) return <Text muted>No {label.toLowerCase()}</Text>;

  return (
    <Text>
      <b>{user.name}</b>
      {user.email && (
        <Fragment>
          <br />
          {user.email}
        </Fragment>
      )}
      {user.phone && (
        <Fragment>
          <br />
          {user.phone}
        </Fragment>
      )}
    </Text>
  );
};

export default UserInfo;



// WEBPACK FOOTER //
// ./src/components/job/UserInfo.js